import { BaseButton, BaseTooltip } from "src/components";

import { useQuery } from "@tanstack/react-query";
import { getAccessDevicesAsync } from "src/api/access/productac-api";
import SpaceBaseTable from "src/pages/product/forms/commonSpaceForm/components/SpaceBaseTable";
import { useModal } from "src/recoil/modalState/hook";
import { axiosInstance } from "src/utils";

const columns = [
  {
    Header: "출입장치 id",
    accessor: "externalDeviceId",
    width: 200,
    Cell: ({ row }: { row: any }) => {
      return (
        <div className="w-full flex-start">
          <BaseTooltip contents={row.original.externalDeviceId || "-"} />
        </div>
      );
    },
  },
  {
    Header: "장치명",
    accessor: "deviceName",
    width: 500,
    Cell: ({ row }: { row: any }) => {
      return (
        <div className="w-full flex-start">
          <BaseTooltip contents={row.original.deviceName || "-"} />
        </div>
      );
    },
  },
];

interface props {
  accessGroupIds?: string; // "1,2,3"
}

const AllAccessDevicesModal = ({ accessGroupIds }: props) => {
  const { setAbstractModalZ1 } = useModal();

  const { data: accessDevicesList } = useQuery({
    queryKey: ["accessDevicesList", accessGroupIds],
    queryFn: () =>
      accessGroupIds
        ? getAccessDevicesAsync(axiosInstance, {
            accessGroupIds: accessGroupIds,
          }).then((res) => res.data.data.content)
        : [],
  });

  return (
    <>
      <section className="base-abstract-modal__title pb20">
        <h1>장치목록 한번에 보기</h1>
      </section>
      <section className="base-abstract-modal__contents px30">
        <SpaceBaseTable
          columns={columns}
          data={accessDevicesList || []}
          ScrollShadowProviderClassName="overflow-visible"
          className="overflow-visible"
          isShowScrollShadow={false}
        />
      </section>
      <section className="base-abstract-modal__btn-wrap">
        <BaseButton title="확인" onClick={() => setAbstractModalZ1({ isOpen: false })} />
      </section>
    </>
  );
};

export default AllAccessDevicesModal;
